import React, { FC, useState } from 'react';

import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { Chip } from '@appcharge/shared-ui';

import Input from 'components/Input/Input';
import RichText from 'components/RichText/RichText';
import { PopupsFormFields } from '../../PopupsForm.consts';

type TagsFieldsProps = {
  tag: string;
  setTag: (value: string) => void;
  currentTags: string[];
  getValues: UseFormGetValues<PopupsFormFields>;
  setValue: UseFormSetValue<PopupsFormFields>;
  tagOptions: string[];
};

const TagsSection: FC<TagsFieldsProps> = ({
  tag,
  setTag,
  currentTags,
  getValues,
  setValue,
  tagOptions
}) => {
  const [tagError, setTagError] = useState('');

  const handleAddTag = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && tag.trim()) {
      e.preventDefault();
      const current = getValues('tags') || [];
      if (
        current.some(
          (s: string) => s.toLowerCase() === tag.trim().toLowerCase()
        )
      ) {
        setTag('');
        return;
      }
      setValue('tags', [...current, tag.trim()], {
        shouldDirty: true,
        shouldValidate: true
      });
      setTag('');
      setTagError('');
    }
  };

  const handleTagChange = (value: string) => {
    setTag(value);
    if (
      currentTags.some((t) => t.toLowerCase() === value.trim().toLowerCase())
    ) {
      setTagError("You can't add the same tag twice");
    } else {
      setTagError('');
    }
  };

  const handleTagBlur = () => {
    setTagError('');
  };

  const handleRemoveTag = (indexToRemove: number) => {
    const currentTags = getValues('tags');
    const updated = currentTags.filter(
      (_: string, i: number) => i !== indexToRemove
    );
    setValue('tags', updated, {
      shouldDirty: true,
      shouldValidate: true
    });
  };

  return (
    <div className="pb-5 border-b border-base-sidebarBorder w-full">
      <RichText
        title="Tags"
        description="Create or add players tags to your offer"
        className="mb-5"
      />
      <Input
        value={tag}
        onChange={(e) => handleTagChange(e.target.value)}
        onKeyDown={handleAddTag}
        onBlur={handleTagBlur}
        description={tagError || "Press 'Enter' to add a new tag"}
        label="Tag Name"
        rightIconStyles="w-[15px] h-[15px] text-[15px]"
        rightIcon={<FontAwesomeIcon icon="fa-regular fa-magnifying-glass" />}
        placeholder="Search Tag"
        list="tag-options"
        state={tagError ? 'error' : 'default'}
      />
      <datalist id="tag-options">
        {tagOptions
          .filter((option) => !currentTags.includes(option))
          .map((option) => (
            <option value={option} key={option} />
          ))}
      </datalist>
      {currentTags.length > 0 && (
        <div className="flex gap-x-2 mt-3">
          {currentTags.map((tag, index) => (
            <Chip
              onClick={() => handleRemoveTag(index)}
              status="primary"
              key={index}
              className="group relative hover:cursor-pointer"
            >
              {tag}
              <FontAwesomeIcon
                icon="fa-regular fa-xmark"
                className="invisible group-hover:visible absolute text-[10px] -right-1.5 -top-1.5 rounded-full bg-base-popoverForeground"
              />
            </Chip>
          ))}
        </div>
      )}
    </div>
  );
};
export default TagsSection;
